import React,{useEffect, useState,useRef} from "react";
import { useSelector,useDispatch } from 'react-redux'
import Layout from "../components/Layout";
import CompetencyForm from './forms/competencyForm';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import {fetchCompetencyOpinion} from '../redux/features/competecnyOpinionfeature'
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { BASE_URL } from '../utils/commonUrl';
import axios from 'axios';
import CompetencyOpinionForm from './forms/CompetencyOpinionForm'

const CompetencyOpinion = () => {
    const dispatch = useDispatch();
    const primeToast = useRef(null)
    const state = useSelector((state) => { return state["competencyOpinion"] })
    const [start] = useState(0);
    const [modal, setModal] = useState(false)
    const [competencyItem, setCompetencyItem] = useState({ competencyOpinionID: 0,
    title: "",
    titleBangla: "",
    weight: 0,
    active: false})

    useEffect(() => {
        dispatch(fetchCompetencyOpinion())
        console.log(state);

    }, [])
    const onSubmit = async data => {
        try {
            const url = BASE_URL + "/api/competencyOpinion";
            const response = await axios.post(url, data);
            if (response.status === 200) {
                primeToast.current.show({ severity: 'success', summary: 'success', detail: 'Competency Save successfully', life: 3000 });
                setCompetencyItem({ competencyOpinionID: 0,
                    title: "",
                    titleBangla: "",
                    weight: 0,
                    active: true});
                setModal(!modal)
                dispatch(fetchCompetencyOpinion())
            }
        } catch (e) {
            console.log(e)
            primeToast.current.show({ severity: 'error', summary: 'error', detail: 'An Error ', life: 3000 });
        }

    }

    const onFormHide = () => {
        setCompetencyItem({ competencyOpinionID: 1,
            title: "TEST SAVE",
            titleBangla: "TEST",
            weight: 1,
            active: true});
        setModal(!modal)
    }
    const editGridData = data => {
        setCompetencyItem({ competencyOpinionID: data.competencyOpinionID,
            title: data.title,
            titleBangla: data.titleBangla,
            weight: data.weight,
            active: data.active});
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteQuarterItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editGridData(rowData)} />
             &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => deleteGridData(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-end'>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Competency Opinion</button>
            </div>
        </div>
    );
    const footer = `In total there are ${state.competencyOpinion ? state.competencyOpinion.length : 0} competency Opinion.`;
    const _isActiveColumn = (rowData) =>{
        return <div>{rowData.active ? <>Active</>:<>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={state.competencyOpinion} header={header} footer={footer} paginator rows={7} first={start}
            paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="competencyOpinionID" header="competency Opinion ID" hidden={true}></Column>
            <Column field='title' header="Title" />
            <Column field='titleBangla' header="Title Bangla" />
            <Column field='weight' header="Weight" />
            <Column field='active' header="Active" body={_isActiveColumn} />
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ minWidth: '4rem' }}></Column>
        </DataTable>
    )
  return (
   <Layout>
       <Toast ref={primeToast}/>
       <CompetencyOpinionForm
       competencyOpinionID={competencyItem.competencyOpinionID}
       title={competencyItem.title}
       titleBangla = {competencyItem.titleBangla}
       weight={competencyItem.weight}
       active = {true}
       modal={modal}
       onSubmit={onSubmit}
       onHide={onFormHide}
       />
    
       {Table}
   </Layout>
  )
}

export default CompetencyOpinion